export default "__VITE_ASSET__990824c5__"